export const GREETINGS = {
  GOOD_MORNING: 'Good morning',
  GOOD_AFTERNOON: 'Good afternoon',
  GOOD_EVENING: 'Good evening',
}

const TIME_RANGES = {
  morning: {start: 5},
  afternoon: {start: 12},
  evening: {start: 18},
}

/**
 * Get a time-based greeting based on the user's local time.
 * Returns "Good morning", "Good afternoon" or "Good evening"
 */
export function getGreeting(displayName: string): string {
  const currentHour = new Date().getHours()

  let greeting = GREETINGS.GOOD_EVENING
  if (currentHour > 0 && currentHour < TIME_RANGES.morning.start) {
    greeting = GREETINGS.GOOD_EVENING
  } else if (currentHour < TIME_RANGES.afternoon.start) {
    greeting = GREETINGS.GOOD_MORNING
  } else if (currentHour < TIME_RANGES.evening.start) {
    greeting = GREETINGS.GOOD_AFTERNOON
  }

  return `${greeting}, ${displayName}!`
}
